import lazySizes from 'lazysizes';
import AOS from 'aos';

lazySizes.init();
AOS.init();

// Barba JS config
//import './barba.js';

// additional modules
import './menu.js';
import './hover-carousel.js'; // desktop on About and Services pages
import './accordion.js'; // mobile on About and Services pages
import './ascii.js'; // art in the console log
import './work-videos.js'; // work page videos
import './work-nav.js'; // work page nav

// adds outlines when the user hits tab

const handleFirstTab = e => {
    if (e.keyCode === 9) {
        // tab key
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
    }
};

window.addEventListener('keydown', handleFirstTab);
